import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PrefOnlySelectState {
  prefOnlySelectJobCount: number;
  prefName: string | null;
  prefOnlyFlg: boolean;
}

export const prefOnlySelectInitialState: PrefOnlySelectState = {
  prefOnlySelectJobCount: 0,
  prefName: null,
  prefOnlyFlg: false,
};

export const prefOnlySelectSlice = createSlice({
  name: 'prefOnlySelect',
  initialState: prefOnlySelectInitialState,
  reducers: {
    setPrefOnlySelectJobCount: (state, action) => {
      state.prefOnlySelectJobCount = action.payload;
    },
    setPrefName: (
      state,
      action: PayloadAction<PrefOnlySelectState['prefName']>
    ) => {
      state.prefName = action.payload;
    },
    setIsPrefOnlyFlg: (state, action) => {
      state.prefOnlyFlg = action.payload;
    },
  },
});

// Create Action
export const { setPrefOnlySelectJobCount, setPrefName, setIsPrefOnlyFlg } =
  prefOnlySelectSlice.actions;

// Reducer
export const prefOnlySelectReducer = prefOnlySelectSlice.reducer;

// Selector
export const prefOnlySelectJobCountSelector = (state) =>
  state.prefOnlyFlg.prefOnlySelectJobCount;

export const prefNameSelector = (state) => state.prefOnlyFlg.prefName;

export const prefOnlyFlgSelector = (state) => state.prefOnlyFlg.prefOnlyFlg;
